import request from './request'

/**
 * 获取短信验证码
 * @param {string} userId 用户ID
 */
export function getTrial(data) {
  return request.get('/win_getPermissionTrial3.php', {
    params: data
  })
}

